import { StudentLibrary } from "@axl-dev/school-sdk";
import { useRef } from "react";

import { useFileProvider } from "@app/shared/lib/hooks";
import {
  GradientPlaceholder,
  Image,
  Loc,
  ValuePlaceholder,
} from "@app/shared/ui";

import { NavigateButton } from "./components/NavigateButton/NavigateButton";

type Props = {
  library: StudentLibrary;
  /** Override title position: "onImage" (default) or "belowImage" */
  titlePosition?: "onImage" | "belowImage";
  /** Override button label */
  buttonLabel?: string;
};

export const LibraryCard: React.FC<Props> = ({ library, titlePosition, buttonLabel }) => {
  const fileProvider = useFileProvider();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const isBelowImage = titlePosition === "belowImage";

  const titleBlock = (
    <div
      className="material-card-title-wrapper"
      title={library.title}
      data-testid="lib-title"
    >
      <ValuePlaceholder
        value={library.title}
        className="material-card-title"
      />
    </div>
  );

  return (
    <div
      className="shadow-sm material-card"
      data-testid="lib-card"
      data-id={library.id}
      onClick={() => buttonRef.current?.click()}
    >
      <div className="material-card-image" data-testid="lib-preview">
        <Image
          src={fileProvider.getUrlByKey(library.primaryImageCloudKey)}
          fit="cover"
          width="100%"
          height="100%"
          placeholder={
            <GradientPlaceholder
              uniq={library.id}
              width="100%"
              height="100%"
              className="material-card-image-placeholder"
            />
          }
        />

        {!isBelowImage && titleBlock}
      </div>

      <div className="material-card-content">
        {isBelowImage && titleBlock}
        <div className="flex flex-col mb-10" data-testid="lib-desc">
          <Loc
            word="Library.descLabel"
            default="Description"
            className="fw-600 secondary-text"
          />
          <div className="material-card-desc">
            <ValuePlaceholder
              value={library.shortDescription}
              placeholder="-"
            />
          </div>
        </div>

        <NavigateButton buttonRef={buttonRef} library={library} buttonLabel={buttonLabel} />
      </div>
    </div>
  );
};
